import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';

const ShieldCheckIcon = ({ className, ...props }: IProps) => {
  const iconClassName = classNames('shield-check-icon', className);

  return (
    <svg
      className={iconClassName}
      width='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M2.34375 7.2207V3.78125C2.34375 3.65693 2.39314 3.5377 2.48104 3.44979C2.56895 3.36189 2.68818 3.3125 2.8125 3.3125H12.1875C12.3118 3.3125 12.431 3.36189 12.519 3.44979C12.6069 3.5377 12.6563 3.65693 12.6563 3.78125V7.2207C12.6563 12.1426 8.47852 13.7715 7.64648 14.0469C7.55196 14.0819 7.44804 14.0819 7.35352 14.0469C6.52148 13.7715 2.34375 12.1426 2.34375 7.2207Z'
        stroke='currentColor'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0781 6.59375L6.63867 9.875L4.92188 8.23438'
        stroke='currentColor'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ShieldCheckIcon;
